import * as React from 'react';
import { RootState } from '../../app/store';
import { connect } from 'react-redux';
import { appRoutesByName } from '../../containers/app/Routes';

import './Conditions.css';

interface OwnProps {
    path: string;
}

interface InjectedProps {
    loading: boolean;
}

type Props = OwnProps & InjectedProps;

export class Conditions extends React.PureComponent<Props> {

    render() {
        const { path, loading } = this.props;
        if ((path === '/' || path === appRoutesByName.products.path)
            && !loading
        ) {
            return (
                <div className="l-content-container">
                    <p className="conditions-text">
                        *Accompanying driver must be an Aviva car insurance policy holder with a full EU
                        driver’s licence held for a continuous period of 2 years in respect of the vehicle
                        category and they must accompany the learner driver at all times. For more terms and
                        conditions, including how to activate your free accompanied driver cover,
                        please click
                        <a target="_blank" rel="noopener" href="http://www.aviva.ie/driving-school/terms/"> here</a>.
                    </p>
                </div>
            );
        } else {
            return null;
        }
    }
}

export function mapStateToProps(state: RootState) {
    return {
        loading: state.products.loading
    };
}

export default connect<InjectedProps>(mapStateToProps)(Conditions);